/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Landing_Operationsdescription1Inputs */

const en_welcome_landing_operationsdescription1 = /** @type {(inputs: Welcome_Landing_Operationsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capital calls, distributions, and reports together in one platform`)
};

/**
* | output |
* | --- |
* | "Capital calls, distributions, and reports together in one platform" |
*
* @param {Welcome_Landing_Operationsdescription1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const welcome_landing_operationsdescription1 = /** @type {((inputs?: Welcome_Landing_Operationsdescription1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Landing_Operationsdescription1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_welcome_landing_operationsdescription1(inputs)
});
export { welcome_landing_operationsdescription1 as "welcome_landing_operationsDescription" }